export enum INVOICE_TYPE {
  INVOICE = 'Invoice',
  VENDOR_BILL = 'VendorBill',
  FUEL_CHARGE = 'FuelCharge',
  WORK_ORDER = 'WorkOrder',
}
export enum PAYMENT_METHOD {
  BANK = 'Bank',
  ACH = 'ACH',
}
export enum JOB_STATUS {
  NEW_REQUEST = 'New Request',
  IN_PROGRESS = 'In Progress',
  COMPLETED = 'Completed',
  CLOSED = 'Closed'
}
export enum JOB_ORDER_STATUS {
  NEW_REQUEST = 'New Request',
  APPROVED = 'Approved',
  SCHEDULED = 'Scheduled',
  REJECTED = 'Rejected',
  // REVIEWED = 'Reviewed',
  IN_PROGRESS = 'In Progress',
  COMPLETED = 'Completed',
}
export enum COST_GROUP {
  MATERIAL = 'Material',
  LABOR = 'Labor',
  EQUIPMENT = 'Equipment',
  TRUCKING = 'Trucking',
  TONNAGE = 'Tonnage',
  PERLOAD = 'Per Load',
}
export enum TYPES {
  TRUCK = 'Truck',
  TRAILER = 'Trailer'
}
export enum REPORT_PERIOD {
  THIS_YEAR_TO_LAST_MONTH = 'this_year_to_last_month',
  LAST_MONTH = 'last_month',
  LAST_QUARTER = 'last_quarter',
  LAST_YEAR = 'last_year'
}
export enum DISPLAY_COLUMN {
  TOTAL_ONLY = 'total_only',
  MONTHS = 'months',
  QUARTERS = 'quarters',
  YEARS = 'years'
}
export enum TIME_PERIOD_CRITERIA {
  TODAY = 'today',
  LAST_DAY = 'last_day',
  TOMORROW = 'tomorrow',
  LAST_SEVEN_DAYS = 'last_seven_days',
  LAST_MONTH = 'last_month',
}
